// Port of api/fuel/app/classes/insights/player/heatmap.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Config from 'offline/model/config'
import Util from 'offline/util'

export default Segment.extend({
	name: 'heatmap',
	types: [Constants.TYPE_USER],
	run: function(type, owner, userIndex, detail, filter) {
		var range = this.get_period_date_range(type, owner, filter || {})
		var format = (((Config.user(owner.get_id()) || {}).insights || {}).heatmap || {}).start || 'sunday'
		var plays = {}
		var total = 0
		var dates = {}
		var playKeys = Object.keys(this._data.plays || {})

		for (var i = 0; i < playKeys.length; i++) {
			var play = this._data.plays[playKeys[i]]
			if (!dates[play.d]) {
				dates[play.d] = {
					play_date: play.d,
					play_count: 0,
					play_index: []
				}
			}
			dates[play.d].play_count += play.c
			dates[play.d].play_index.push(play.id)
		}

		if (filter.period === 'all') {
			var dateKeys = Object.keys(dates)
			for (var dk = 0; dk < dateKeys.length; dk++) {
				var item = dates[dateKeys[dk]]
				var week = Util.weekofyear(item.play_date, format === 'sunday')
				var stamp = Util.date('Y', item.play_date) + '/' + week
				if (!plays[stamp]) plays[stamp] = { count: 0, index: [] }
				plays[stamp].count += item.play_count
				plays[stamp].index = item.play_index.concat(plays[stamp].index)
				total += item.play_count
			}
		} else {
			var keys = Object.keys(dates)
			for (var k = 0; k < keys.length; k++) {
				var daily = dates[keys[k]]
				if (!plays[daily.play_date]) plays[daily.play_date] = { count: 0, index: [] }
				plays[daily.play_date].count += daily.play_count
				plays[daily.play_date].index = daily.play_index.concat(plays[daily.play_date].index)
				total += daily.play_count
			}
		}

		if (range.start < 0) {
			var playStamps = Object.keys(plays)
			for (var ps = 0; ps < playStamps.length; ps++) {
				var parts = String(playStamps[ps]).split('/')
				var time = Util.mktime(0, 0, 0, [1, 1, parseInt(parts[0], 10)])
				if (range.start < 0 || time < range.start) range.start = time
			}
		}

		return {
			heatmap: {
				start: range.start,
				end: range.end,
				plays: plays,
				total: total
			}
		}
	}
})
